module.exports = __webpack_public_path__ + "img/16.699bdb38.jpg";